import React, { PureComponent } from 'react';
import { Flex } from '../../../common/Flex';
import { CountType, FlightId, TimePeriod } from '../../../../model/CORE';
import {
    ConfiguredAirspace,
    ExtendedMonitoredTv,
    MonitoredMcdmMeasure,
    MonitoredMeasure,
} from '../../../../model/SOL49';
import { ConfigurableAirspace } from './ConfigurableAirspace';
import { SortUtils } from '../../../../common/util/SortUtils';

interface SectorFlowsProps {
    currentTime: Date;
    monitoredPeriod: TimePeriod;
    configuredAirspaces?: Array<ConfiguredAirspace>;
    monitoredTvs: Array<ExtendedMonitoredTv>;
    monitoredMeasures: Array<MonitoredMeasure>;
    monitoredMcdmMeasures: Array<MonitoredMcdmMeasure>;
    countType: CountType;
    tvsOccupancyPeriods?: { [key: string]: Map<FlightId, TimePeriod> };
    selectedPeriodByTv?: Map<string, Array<TimePeriod>>;
    onSelectedPeriodByTvChange?: (selectedPeriodByTv: Map<string, Array<TimePeriod>>) => void;
}

export class SectorFlows extends PureComponent<SectorFlowsProps> {
    renderConfiguredAirspaces = () => {
        if (!this.props.configuredAirspaces) return null;

        return this.props.configuredAirspaces
            .sort(SortUtils.CONFIGURED_AIRSPACE_ALPHABETICAL_SORTING)
            .map(configuredAirspace => (
                <ConfigurableAirspace
                    key={`configured-airspace-${configuredAirspace.airspace.id}`}
                    currentTime={this.props.currentTime}
                    monitoredPeriod={this.props.monitoredPeriod}
                    monitoredTvs={this.props.monitoredTvs}
                    monitoredMeasures={this.props.monitoredMeasures}
                    monitoredMcdmMeasures={this.props.monitoredMcdmMeasures}
                    airspace={configuredAirspace.airspace.id}
                    sectorOpenings={configuredAirspace.sectorOpenings}
                    countType={this.props.countType}
                    tvsOccupancyPeriods={this.props.tvsOccupancyPeriods}
                    selectedPeriodByTv={this.props.selectedPeriodByTv}
                    onSelectedPeriodByTvChange={this.props.onSelectedPeriodByTvChange}
                />
            ));
    };

    render() {
        return <Flex direction="vertical">{this.renderConfiguredAirspaces()}</Flex>;
    }
}
